import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/contexts/AuthContext'
import { TenantProvider } from '@/contexts/TenantContext'
import { TooltipProvider } from '@/components/ui/Tooltip'
import { ToastContextProvider } from '@/components/ui/Toast'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: (failureCount, error) => {
        if (error instanceof Error && error.message.includes('401')) return false
        return failureCount < 2
      },
    },
  },
})

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TenantProvider>
          <ToastContextProvider>
            <TooltipProvider>
              {children}
            </TooltipProvider>
          </ToastContextProvider>
        </TenantProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
